export default __webpack_public_path__ + "assets/images/back-icon-mask.fae3c934a7353e1defbb00343509b3aa.png";